export const noOp = () => undefined;
